module.exports = __webpack_public_path__ + "static/media/logo.f3bbd8b6.svg";